import React from 'react';

const ScrollDownButton = ({ onClick, isShow }) => {
  return (
    <button
      type={'button'}
      className={`button-default scroll-down-button ${isShow ? 'is-show' : ''}`}
      aria-label={'Scroll Down'}
      onClick={onClick}
    >
      <i className={'icon icon-scroll-down'} />
    </button>
  );
};

export default ScrollDownButton;
